<template>
  <el-form-item :label="i18nt('designer.setting.cancelChecked')">
    <el-switch v-model="optionModel.cancelChecked"></el-switch>
  </el-form-item>
</template>

<script>
import i18n from "@/utils/i18n"

export default {
  name: "cancelChecked-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object,
  },
}
</script>

<style scoped></style>
